module.exports = __webpack_public_path__ + "f931594b9dbb29db4713d6c6be867098.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-320.webp.png
// module id = 619
// module chunks = 0